import React from "react";

const Device = ({ device, isSelected, onSelectionChange }) => {
  const getBatteryColor = (percentage) => {
    if (percentage <= 10) return "#dc3545"; // Red
    if (percentage <= 25) return "#fd7e14"; // Orange
    if (percentage <= 50) return "#ffc107"; // Yellow
    return "#28a745"; // Green
  };

  const formatLastSeen = (timestamp) => {
    if (!timestamp) return "Never";

    const date = new Date(timestamp);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);

    if (diffInMinutes < 1) return "Just now";
    if (diffInMinutes < 60)
      return `${diffInMinutes} min${diffInMinutes === 1 ? "" : "s"} ago`;
    if (diffInHours < 24)
      return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;

    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
  };

  const {
    name,
    batteryLevel: batteryPercentage,
    online,
    charging,
    last_seen: lastReport,
  } = device;

  const hasBatteryReading = Number.isFinite(batteryPercentage);
  const batteryColor = hasBatteryReading
    ? getBatteryColor(batteryPercentage)
    : "#6c757d";

  return (
    <div
      style={{
        border: `2px solid ${isSelected ? "#007bff" : "#e9ecef"}`,
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: isSelected ? "#f0f8ff" : "white",
        boxShadow: isSelected
          ? "0 2px 8px rgba(0, 123, 255, 0.1)"
          : "0 1px 4px rgba(0,0,0,0.05)",
        position: "relative",
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      onClick={() => onSelectionChange(!isSelected)}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Device Name */}
        <h3
          style={{
            margin: "10px 0",
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: 1,
            textAlign: "left",
            paddingLeft: "4px",
            letterSpacing: "0.3px",
          }}
        >
          {name}
        </h3>
        {/* Monitoring Toggle */}
        <div
          onClick={(e) => {
            e.stopPropagation();
            onSelectionChange(!isSelected);
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            backgroundColor: isSelected ? "#007bff" : "#f1f3f5",
            padding: "6px 10px",
            borderRadius: "16px",
            border: `1px solid ${isSelected ? "#007bff" : "#ccc"}`,
            fontSize: "12px",
            fontWeight: "bold",
            color: isSelected ? "white" : "#555",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
        >
          <span>{isSelected ? "🔔" : "🔕"}</span>
          <span>{isSelected ? "Monitoring" : "Disabled"}</span>
        </div>
      </div>

      {/* Battery Section */}
      <div
        style={{
          padding: "12px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px solid #e9ecef",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <div>
            <span
              style={{
                backgroundColor: "#28a745",
                color: "white",
                padding: "4px 8px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {charging ? "⚡ Charging" : online ? "🟢 Online" : "🔴 Offline"}
            </span>
            {/* Last Seen */}
            <span
              style={{
                fontSize: "12px",
                color: "#666",
                padding: "5px",
              }}
            >
              {formatLastSeen(lastReport)}
            </span>
          </div>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              color: batteryColor,
            }}
          >
            🔋 {hasBatteryReading ? `${batteryPercentage}%` : "—"}
          </span>
        </div>

        {/* Battery Level Bar */}
        <div
          style={{
            width: "100%",
            height: "6px",
            backgroundColor: "#e9ecef",
            borderRadius: "3px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: hasBatteryReading ? `${batteryPercentage}%` : "0%",
              height: "100%",
              backgroundColor: batteryColor,
              transition: "width 0.3s ease",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Device;
